import React, { useEffect, useState } from "react";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from "@mui/material";
import SessionsCustomCheckbox from "./SessionsCustomCheckbox";
import SessionsMemberRow from "./SessionsMemberRow";
import data from "./data"; // You can move your data to a separate file
import SessionsMemberRowSkeleton from "./SessionsMemberRowSkeleton";
import NoData from "../../NoData/NoData";

const cellStyle = {
    padding: '10px 16px',
};

const SessionsProjectActivityTable = ({ isMeView = false }) => {
    const [selectedRows, setSelectedRows] = useState([]);



    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);  // Ensure this gets called
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    const handleSelectAll = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(data.map((row) => row.id));
        }
    };

    const handleRowToggle = (id) => () => {
        setSelectedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const allSelected = selectedRows.length === data.length;
    const someSelected = selectedRows.length > 0 && !allSelected;




    return (
        <TableContainer component={Paper} sx={{ boxShadow: 'none', background: 'transparent' }}>
            <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 5px' }}>
                <TableHead sx={{ backgroundColor: '#DFDFDF' }}>
                    <TableRow>
                        <TableCell sx={{
                            ...cellStyle,
                            border: 'none',
                            minWidth: '32px',
                            maxWidth: '32px',
                            borderTopLeftRadius: '10px',
                            borderBottomLeftRadius: '10px'
                        }}>
                            <SessionsCustomCheckbox
                                checked={allSelected}
                                indeterminate={someSelected}
                                onChange={handleSelectAll}
                            />
                        </TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>#</TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Project</TableCell>
                        {!isMeView && (<TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>Members</TableCell>)}
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>Manual</TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center' }}>Duration</TableCell>
                        <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Activity</TableCell>
                        <TableCell sx={{
                            ...cellStyle,
                            border: 'none',
                            borderTopRightRadius: '10px',
                            borderBottomRightRadius: '10px',
                            textAlign: 'center',
                        }}>
                            Notes
                        </TableCell>
                    </TableRow>
                </TableHead>
                {/* <TableBody>
                    {loading
                        ? [...Array(3)].map((_, i) => <MemberRowSkeleton key={i} />)
                        : data.map((row) => (
                            <MemberRow
                                key={row.id}
                                row={row}
                                isSelected={selectedRows.includes(row.id)}
                                onSelectToggle={handleRowToggle(row.id)}
                            />
                        ))}
                </TableBody> */}
                <TableBody>
                    {loading ? (
                        [...Array(3)].map((_, i) => <SessionsMemberRowSkeleton key={i} isMeView={isMeView} />)
                    ) : data.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={8} align="center" sx={{ padding: '40px 16px' }}>
                                <NoData />
                            </TableCell>
                        </TableRow>
                    ) : (
                        data.map((row) => (
                            <SessionsMemberRow
                                key={row.id}
                                row={row}
                                isSelected={selectedRows.includes(row.id)}
                                onSelectToggle={handleRowToggle(row.id)}
                                isMeView={isMeView}
                            />
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SessionsProjectActivityTable;